export const ENV_NAME = 'staging';
export const DISABLE_ANALYTICS = true;
export const BASE_URL = 'https://api-staging.getoutpatient.com/';
export const BASE_WS_URL = 'wss://ws-staging-web.getoutpatient.com';
export const CLOUD_PROVIDER = 'aws'; // aws | azure
export const S3_PUBLIC_BUCKET_URL =
  'https://duploservices-staging01-op-dev-public-299363876794.s3.us-gov-east-1.amazonaws.com/';
export const TURNSTYLE_SITE_KEY = '0x4AAAAAAAGsiZ8e9RgHaKUR';
export const USE_OKTA = false;
